var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 25"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 12,
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "History_6_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M39.6116 47.0001C41.178 47.0001 42.4479 45.7389 42.4479 44.1832V39.4297",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.7794 22.0353V44.1832",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M45.2842 12H19.6157C18.0493 12 16.7794 13.2612 16.7794 14.8169V19.5704",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M42.4479 36.9648V14.8169",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M42.4479 14.8169C42.4479 13.2612 43.7178 12 45.2842 12C46.5187 12 47.569 12.7833 47.9587 13.8768C48.1221 14.3354 47.7798 14.8169 47.29 14.8169H42.4479Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M23.3511 36.4366H35.8763",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M23.3511 39.9578H35.8763",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M24.7439 27.3874C24.7439 24.3395 27.2405 21.8593 30.3101 21.8593C33.3797 21.8593 35.8764 24.3395 35.8764 27.3874C35.8764 30.4353 33.3797 32.9156 30.3101 32.9156C28.7757 32.9156 27.3838 32.2959 26.3762 31.2945",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M30.3101 24.6761V27.3874H32.4727",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M23.3511 25.3173L24.7438 27.3875L26.8283 26.0042",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M35.6002 44.1831H13.71C13.2202 44.1831 12.8779 44.6646 13.0412 45.1232C13.4309 46.2166 14.4813 47 15.7158 47H39.6116C38.3761 47 37.3251 46.2154 36.9362 45.1206C36.7365 44.5584 36.2005 44.1831 35.6002 44.1831Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M24.5474 16.2252C24.7878 16.4992 25.1416 16.6727 25.5363 16.6727C25.9311 16.6727 26.2847 16.4993 26.5253 16.2252",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M34.68 16.2253C34.4396 16.4994 34.0858 16.6728 33.6911 16.6728C33.2964 16.6728 32.9427 16.4994 32.7021 16.2253",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M29.5188 17C28.9665 17 28.5188 17.4477 28.5188 17.9999C28.5188 18.5522 28.9665 18.9998 29.5188 18.9998C30.071 18.9998 30.5187 18.5521 30.5187 17.9999C30.5187 17.4477 30.071 17 29.5188 17Z",
    fill: "white"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg1);
export default __webpack_public_path__ + "static/media/img1.9870cb9894107389e72cb93f6b9cb3d5.svg";
export { ForwardRef as ReactComponent };